export const siteConfig = {
  brandName: "Beautify Ourselves",
  siteUrl: "https://beautifyourselves.com",
  currency: "GBP",
  commerceEnabled: false,
  prelaunchNotice: "Coming soon — orders are not currently available.",
  delivery: {
    uk: {
      estimate: "5–7 business days from order confirmation",
      notice:
        "Estimated UK delivery: 5–7 business days from order confirmation. We’ll let you know if your order is delayed.",
      shipping:
        "Available UK delivery options and charges will be shown before checkout."
    },
    ireland: {
      estimate: null,
      notice: "Delivery times will be published when confirmed.",
      shipping:
        "Available Republic of Ireland delivery options and charges will be shown before checkout."
    }
  }
} as const;
